// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TX4e","textarea":"styles_textarea__2sTUp"};